import { FC } from 'react';
import { CodeEditor, DescriptionBlock, EmptyText } from '../../../../../common/components';
import { CodeEditorLanguage } from '../../../../../common/components/CodeEditor/CodeEditor.interface';
import { Button, Col, Popconfirm, Row, theme } from 'antd';
import { Domain } from '../../../entities';
import { getDateFactory } from '../../../../../common/utils';
import { CommonDrawerTitle } from '../../../../../common/layouts';
import { ArrowRepeat, ExclamationCircle } from 'react-bootstrap-icons';

interface Props {
  sitemapLastGeneratedAt: Domain['sitemapLastGeneratedAt'];
  sitemapContent: Domain['sitemap'];
  isGenerateSitemapLoading: boolean;
  handleGenerateSitemap: () => void;
}

export const SitemapDossierView: FC<Props> = ({
  sitemapContent,
  sitemapLastGeneratedAt,
  isGenerateSitemapLoading,
  handleGenerateSitemap
}) => {
  const { token } = theme.useToken();

  return (
    <>
      <CommonDrawerTitle
        onlyExtra
        extra={
          <Popconfirm
            disabled={ isGenerateSitemapLoading }
            title="Згенерувати sitemap?"
            onConfirm={ handleGenerateSitemap }
            okType="danger"
            okText="Так"
            icon={ <ExclamationCircle color={ token.colorError }/> }
            placement="bottomRight"
          >
            <Button loading={ isGenerateSitemapLoading } disabled={ isGenerateSitemapLoading } icon={ <ArrowRepeat/> }>
              Згенерувати
            </Button>
          </Popconfirm>
        }
      />

      <Row gutter={ [0, 16] }>
        <Col span={ 24 }>
          <DescriptionBlock
            items={ [
              ['Дата генерації', sitemapLastGeneratedAt ? getDateFactory(sitemapLastGeneratedAt, 'August 16, 2018 08:02', true) : <EmptyText/>]
            ] }
          />
        </Col>

        <Col span={ 24 }>
          <CodeEditor language={ CodeEditorLanguage.Xml } value={ sitemapContent } readOnly disableMinimap/>
        </Col>
      </Row>
    </>
  );
};
